<script lang="ts">
    import { mdiPencil, mdiTrashCanOutline } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { createEventDispatcher } from "svelte"

    export let address: BigCommerceAddress
    const dispatcher = createEventDispatcher()
</script>

<li>
    <div class="wrapper">
        <h4>{address.first_name || ""} {address.last_name || ""}</h4>
        <div class="content">
            <p>{address.address1}</p>
            {#if address.address2}
                <p>{address.address2}</p>
            {/if}
            <p>{address.postal_code} {address.city} ({address.state_or_province})</p>
            <p>{address.country}</p>
        </div>
    </div>
    <div class="action-line">
        <p>Wohnadresse</p>

        <span>
            <button
                class="btn transparent"
                on:click="{() => dispatcher('edit')}"
                ><Icon path="{mdiPencil}" />
            </button>
            <button
                class="btn transparent"
                on:click="{() => dispatcher('delete')}"><Icon path="{mdiTrashCanOutline}" /></button
            >
        </span>
    </div>
</li>

<style lang="less">
    li {
        .wrapper {
            display: flex;
            flex-direction: column;
            gap: 1.2rem;
            border: 1px solid var(--bg-100);
            padding: 24px;
            h4 {
                font-size: 1.2rem;
                font-weight: normal;
            }
            .content {
                display: flex;
                flex-direction: column;
                gap: 6px;
                align-items: flex-start;
            }
        }
        .action-line {
            background: var(--bg-100);
            padding: 6px 12px;
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 26px;
            justify-content: space-between;
            p,
            span {
                color: var(--neutral-white);
                text-transform: uppercase;
                font-size: 0.7rem;
                font-weight: bold;
                display: flex;
                gap: 10px;
            }
        }
    }
</style>
